import { ErrorHandler, Inject, Injectable, Injector, NgZone } from "@angular/core";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import * as Sentry from "@sentry/angular";
import { environment } from "src/environments/environment";
import { ErrorTypeEnum } from "./contract/error-handler.contract";

@Injectable({
  providedIn: "root",
})
/**
 * @description This service is used to show message data for UnprocessableContent errors and them send them to Sentry.
 */
export class ErrorHandlerService implements ErrorHandler {
  constructor(@Inject(Injector) private injector: Injector, private zone: NgZone) {}

  // Use MatSnackBar for error notifications
  private get snackBar(): MatSnackBar {
    return this.injector.get(MatSnackBar);
  }

  handleError(error: any): void {
    // Handle errors here before sending to Sentry

    const errorCode = error?.statusCode || error?.rejection?.statusCode;
    if (errorCode === ErrorTypeEnum.UnprocessableContent) {
      let errorMessage: string = "";
      if (error.rejection && error.rejection.detail && error.rejection.detail.message) {
        errorMessage = error.rejection.detail.message;
      }

      if (!!errorMessage) {
        this._showError(errorMessage);
      }
    } else {
      this._showError("Something went wrong. Please try again.");
      if (!environment.production) {
        console.error(error);
      }
    }

    // Send error to Sentry
    if (error) {
      Sentry.captureException(error.originalError || error);
    }
  }

  private _showError(errorMessage: string): void {
    const horizontalPosition: MatSnackBarHorizontalPosition = "end";
    const verticalPosition: MatSnackBarVerticalPosition = "top";
    this.zone.run(() => {
      this.snackBar.open(errorMessage, "Close", {
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        panelClass: "snackbar-error",
        duration: 4000,
      });
    });
  }
}
